import type { ProductRuleName } from '../../contract/market';

export type ProductType = 'easy_term' | 'master_term';

export interface ProductRuleContext {
  insuredAmount: number;
  residenceCountry: string;
  easyTermMax: number | null;
}

const SPECIAL_RESIDENCE_COUNTRIES = ['CL', 'AR', 'UY'];
const LEGACY_SPECIAL_MAX = 2000000;
const LEGACY_COMMON_MAX = 1000000;

export const PRODUCT_RULES: Record<ProductRuleName, (ctx: ProductRuleContext) => ProductType> = {
  coverageBands: ({ insuredAmount, easyTermMax }) =>
    insuredAmount <= (easyTermMax ?? LEGACY_COMMON_MAX) ? 'easy_term' : 'master_term',

  legacyThreshold: ({ insuredAmount, residenceCountry }) =>
    (SPECIAL_RESIDENCE_COUNTRIES.includes(residenceCountry) && insuredAmount <= LEGACY_SPECIAL_MAX) ||
    insuredAmount <= LEGACY_COMMON_MAX
      ? 'easy_term'
      : 'master_term',
};
